var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChequeCadeauIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.50011 14H4.49989C4.63253 14 4.75973 14.0527 4.85352 14.1465C4.94731 14.2403 5 14.3675 5 14.5001V21.4999C5 21.6325 4.94731 21.7597 4.85352 21.8535C4.75973 21.9473 4.63253 22 4.49989 22H1.50011C1.36747 22 1.24027 21.9473 1.14648 21.8535C1.05269 21.7597 1 21.6325 1 21.4999V14.5001C1 14.3675 1.05269 14.2403 1.14648 14.1465C1.24027 14.0527 1.36747 14 1.50011 14V14Z",
    stroke: "#162056",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 20.5857C15.5284 24.0547 12.3003 24.1535 23.7235 18.446C23.7993 18.4073 23.864 18.3505 23.9119 18.2807C23.9598 18.2109 23.9892 18.1304 23.9976 18.0465C24.0059 17.9627 23.9929 17.878 23.9596 17.8004C23.9264 17.7227 23.8741 17.6545 23.8074 17.602C23.4812 17.3218 23.0866 17.1305 22.6627 17.0472C22.2388 16.9638 21.8002 16.9913 21.3903 17.1268L16.1883 18.8355",
    stroke: "#162056",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2173 19H15.9565C16.0936 19 16.2293 18.9741 16.3559 18.9239C16.4825 18.8736 16.5975 18.8 16.6944 18.7071C16.7913 18.6142 16.8681 18.504 16.9206 18.3827C16.973 18.2614 17 18.1313 17 18C17 17.8687 16.973 17.7386 16.9206 17.6173C16.8681 17.496 16.7913 17.3858 16.6944 17.2929C16.5975 17.2 16.4825 17.1264 16.3559 17.0761C16.2293 17.0259 16.0936 17 15.9565 17H12.8261C11.5894 15.7769 9.90652 15.0601 8.1304 15H5",
    stroke: "#162056",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 7V12.4999C11 12.6325 11.0527 12.7597 11.1465 12.8535C11.2403 12.9473 11.3675 13 11.5001 13H20.4999C20.6325 13 20.7597 12.9473 20.8535 12.8535C20.9473 12.7597 21 12.6325 21 12.4999V7",
    stroke: "#162056",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5001 4H21.4999C21.6325 4 21.7597 4.05269 21.8535 4.14647C21.9473 4.24026 22 4.36746 22 4.5001V6.4999C22 6.63254 21.9473 6.75974 21.8535 6.85353C21.7597 6.94731 21.6325 7 21.4999 7H10.5001C10.3675 7 10.2403 6.94731 10.1465 6.85353C10.0527 6.75974 10 6.63254 10 6.4999V4.5001C10 4.36746 10.0527 4.24026 10.1465 4.14647C10.2403 4.05269 10.3675 4 10.5001 4V4Z",
    stroke: "#162056",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 13V4",
    stroke: "#162056",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2443 2.78305C18.283 3.34851 17.1795 3.76243 16 4C16.3167 3.1146 16.8684 2.28632 17.622 1.56486C18.6303 0.807977 19.2014 0.92522 19.6525 1.26013C20.1037 1.59504 20.2523 2.02616 19.2443 2.78305Z",
    stroke: "#162056",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7558 2.78274C13.717 3.34831 14.8205 3.76234 16 4C15.6831 3.11463 15.1314 2.28641 14.3779 1.56498C13.3694 0.808395 12.7983 0.924925 12.3475 1.25992C11.8966 1.59492 11.7473 2.02566 12.7558 2.78274Z",
    stroke: "#162056",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChequeCadeauIcon);
export default __webpack_public_path__ + "static/media/cheque_cadeau_icon.b0fe55301bf875a0c18a5c6ffc98b9ac.svg";
export { ForwardRef as ReactComponent };